<div class="min-h-screen bg-slate-50 p-4">
      <div class="max-w-6xl mx-auto space-y-4">


            <!-- Compact Header -->
            <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-4">
                  <div class="flex items-center justify-between">

                        <!-- Title -->
                        <div>
                              <h2 class="text-lg font-semibold text-slate-800">
                                    Validation Rules
                              </h2>
                              <p class="text-xs text-slate-500">
                                    Manage validation rules
                              </p>
                        </div>

                        <!-- Right side -->
                        <div class="flex items-center gap-3">

                              <!-- Search with icon -->
                              <div class="relative">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                          <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                                    </div>

                                    <input type="text" [(ngModel)]="searchTerm" (input)="filterRules()"
                                          placeholder="Search..." class="w-44 pl-9 pr-3 py-1.5 text-sm border border-slate-300 rounded-md
                       focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
                              </div>

                              <!-- Button -->
                              <button (click)="openCreateModal()" class="bg-blue-600 hover:bg-blue-700 text-white
                     px-4 py-1.5 text-sm rounded-md font-medium">
                                    + Create Rule
                              </button>

                        </div>
                  </div>
            </div>


            <!-- Compact Table -->
            <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
                  <div class="overflow-x-auto">
                        <table class="w-full text-sm">

                              <!-- Header -->
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 uppercase text-[11px]">
                                          <th class="px-3 py-2 text-left">Entity</th>
                                          <th class="px-3 py-2">Code</th>
                                          <th class="px-3 py-2">Type</th>
                                          <th class="px-3 py-2">Message</th>
                                          <th class="px-3 py-2">Phase</th>
                                          <th class="px-3 py-2">Scope</th>
                                          <th class="px-3 py-2">Severity</th>
                                          <th class="px-3 py-2">Status</th>
                                          <th class="px-3 py-2 text-right">Actions</th>
                                    </tr>
                              </thead>

                              <!-- Body -->
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let rule of paginatedRules" class="hover:bg-slate-50">

                                          <td class="px-3 py-2 font-medium text-slate-700">
                                                {{ rule.entityName }}
                                          </td>

                                          <td class="px-3 py-2 font-mono text-slate-600">
                                                {{ rule.ruleCode }}
                                          </td>

                                          <td class="px-3 py-2">
                                                <span class="px-2 py-0.5 rounded bg-slate-100 text-slate-700 text-xs">
                                                      {{ rule.ruleType }}
                                                </span>
                                          </td>

                                          <td class="px-3 py-2 text-slate-500 truncate max-w-[200px]">
                                                {{ rule.message || '-' }}
                                          </td>

                                          <td class="px-3 py-2 text-slate-600">
                                                {{ rule.phase }}
                                          </td>

                                          <td class="px-3 py-2 text-slate-600">
                                                {{ rule.scope }}
                                          </td>

                                          <td class="px-3 py-2 text-center">
                                                <span class="px-2 py-0.5 rounded-full text-xs font-medium" [ngClass]="{
                      'bg-red-100 text-red-700': rule.severity === 'ERROR',
                      'bg-amber-100 text-amber-700': rule.severity === 'WARNING',
                      'bg-blue-100 text-blue-700': rule.severity === 'INFO'
                    }">
                                                      {{ rule.severity }}
                                                </span>
                                          </td>

                                          <td class="py-3 px-4 text-center">
                                                <div class="flex items-center justify-center gap-1.5">
                                                      <span class="relative flex h-2.5 w-2.5">
                                                            <span *ngIf="rule.active"
                                                                  class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                                                            <span class="relative inline-flex rounded-full h-2.5 w-2.5"
                                                                  [ngClass]="rule.active ? 'bg-emerald-500' : 'bg-slate-300'"></span>
                                                      </span>
                                                      <span class="text-xs font-medium"
                                                            [class.text-slate-400]="!rule.active"
                                                            [class.text-slate-700]="rule.active">
                                                            {{ rule.active ? 'Active' : 'Inactive' }}
                                                      </span>
                                                </div>
                                          </td>

                                          <td class="py-3 px-4 text-right">
                                                <div class="flex items-center justify-end gap-3">
                                                      <button (click)="openEditModal(rule)"
                                                            class="text-slate-400 hover:text-blue-600 transition-colors"
                                                            title="Edit">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                                                  </path>
                                                            </svg>
                                                      </button>

                                                      <button (click)="deleteRule(rule.id)"
                                                            class="text-slate-400 hover:text-red-600 transition-colors"
                                                            title="Delete">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                  </path>
                                                            </svg>
                                                      </button>
                                                </div>
                                          </td>

                                    </tr>

                                    <!-- Empty state -->
                        <tr *ngIf="rules.length === 0">
                              <td colspan="9" class="py-8 text-center text-slate-400">
                                    No validation rules found
                              </td>
                        </tr>

                              </tbody>
                        </table>
                  </div>
                  <!--  -->
                  <div
                        class="kt-card-footer flex flex-wrap items-center justify-between gap-4 px-4 py-2.5 bg-white border-t border-slate-200 text-xs font-medium">
                        <div class="flex items-center gap-3 text-sm font-bold text-black-600">
                              <span>Show</span>
                              <select [value]="pageSize" (change)="changePageSize($event)"
                                    class="kt-select w-20 border-2 border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-800 font-bold outline-none focus:border-blue-500 transition-all cursor-pointer shadow-sm text-sm">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="50">50</option>
                              </select>
                              <span>per page</span>
                        </div>
                        <div class="flex items-center gap-6 text-black-600 font-medium">
                              <span class="hidden sm:inline-block text-sm">
                                    {{ pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize > total ? total :
                                    (pageIndex + 1) *
                                    pageSize }}
                                    of {{ total }}
                              </span>
                              <div class="flex items-center gap-2">
                                    <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                                          class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M15 19l-7-7 7-7">
                                                </path>
                                          </svg>
                                    </button>
                                    <div
                                          class="w-9 h-9 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold text-sm shadow-inner">
                                          {{ pageIndex + 1 }}
                                    </div>
                                    <button (click)="goToPage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
                                          class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M9 5l7 7-7 7">
                                                </path>
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
                  <!--  -->
            </div>
      </div>
</div>


<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

      <div class="bg-white rounded-lg shadow-xl w-full max-w-xl p-5 space-y-4">

            <div class="flex justify-between items-center">
                  <h3 class="text-base font-semibold text-slate-800">
                        {{ isEditMode ? 'Edit' : 'Create' }} Validation Rule
                  </h3>
                  <button (click)="closeModal()"
                        class="text-gray-400 hover:text-gray-600 text-sm transition-colors">✕</button>
            </div>

            <div class="grid grid-cols-2 gap-3 text-sm">

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Entity Name</label>
                        <input [(ngModel)]="currentRule.entityName"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                  </div>

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Rule Code</label>
                        <input [(ngModel)]="currentRule.ruleCode"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
                  </div>

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Phase</label>
                        <select [(ngModel)]="currentRule.phase"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white">
                              <option value="COMPUTATIONAL">COMPUTATIONAL</option>
                              <option value="STRUCTURAL">STRUCTURAL</option>
                              <option value="PRE_SAVE">PRE_SAVE</option>
                              <option value="POST_SAVE">POST_SAVE</option>
                        </select>
                  </div>

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Scope</label>
                        <select [(ngModel)]="currentRule.scope"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white">
                              <option value="FIELD">FIELD</option>
                              <option value="FORM">FORM</option>
                              <option value="COLLECTION">COLLECTION</option>
                        </select>
                  </div>

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Rule Type</label>
                        <select [(ngModel)]="currentRule.ruleType"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white">
                              <option value="DSL">DSL (JSON)</option>
                              <option value="SQL">SQL</option>
                        </select>
                  </div>

                  <div>
                        <label class="text-xs text-slate-500 mb-1 block">Severity</label>
                        <select [(ngModel)]="currentRule.severity"
                              class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white">
                              <option value="ERROR">ERROR</option>
                              <option value="WARNING">WARNING</option>
                              <option value="INFO">INFO</option>
                        </select>
                  </div>

            </div>

            <div>
                  <label class="text-xs text-slate-500 mb-1 block">Message</label>
                  <input [(ngModel)]="currentRule.message"
                        class="w-full border border-slate-300 rounded px-2 py-1.5 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-sm">
            </div>

            <div *ngIf="currentRule.ruleType === 'DSL'">
                  <label class="text-xs text-slate-500 mb-1 block">Rule JSON</label>
                  <textarea [(ngModel)]="jsonString"
                        class="w-full h-24 border border-slate-300 rounded px-2 py-1.5 text-xs font-mono focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"></textarea>
            </div>

            <div *ngIf="currentRule.ruleType === 'SQL'">
                  <label class="text-xs text-slate-500 mb-1 block">SQL Expression</label>
                  <textarea [(ngModel)]="currentRule.sqlExpression"
                        class="w-full h-24 border border-slate-300 rounded px-2 py-1.5 text-xs font-mono focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"></textarea>
            </div>

            <div class="mt-1">
                  <label class="flex items-center gap-2 text-sm text-slate-700 cursor-pointer w-fit">
                        <input type="checkbox" [(ngModel)]="currentRule.active"
                              class="rounded border-slate-300 text-blue-600 focus:ring-blue-500">
                        Active
                  </label>
            </div>

            <div class="flex justify-end gap-2 pt-3 mt-2 border-t border-slate-100">
                  <button (click)="closeModal()"
                        class="px-4 py-1.5 border border-slate-300 text-slate-700 rounded-md text-sm hover:bg-slate-50 transition-colors">
                        Cancel
                  </button>
                  <button (click)="save()"
                        class="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors">
                        {{ isEditMode ? 'Update' : 'Save' }}
                  </button>
            </div>

      </div>
</div>